module.exports = __webpack_public_path__ + "img/feedback3-1.9e8d85e7.jpg";